import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { ExternalLink } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';
import { getStoredFunMode, translate } from '../i18n';

export const externalToolsRouteRef = createRouteRef();

export const externalToolsPage = PageBlueprint.make({
  params: {
    path: '/external-tools',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate('externalTools.nav.title', getStoredFunMode()),
    icon: <ExternalLink size={20} strokeWidth={2} />,
    routeRef: externalToolsRouteRef,
    noHeader: true,
    loader: () =>
      import('./ExternalToolsPage').then(m => (
        <PageShareTitle title="External tools">
          <m.ExternalToolsPage />
        </PageShareTitle>
      )),
  },
});

export const externalToolsPlugin = createFrontendPlugin({
  pluginId: 'external-tools',
  extensions: [externalToolsPage],
});
